/** @format */

import { MapContainer, Marker, TileLayer, useMapEvents } from "react-leaflet";
import { useRef, useMemo } from "react";
import { useRouter } from "next/router";
import { usePos } from "../utils/standort";
import L from "leaflet";
import { FullscreenControl } from "react-leaflet-fullscreen";
import "react-leaflet-fullscreen/dist/styles.css";

const icon = L.icon({
  iconUrl: "/images/MapMarker.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [15, 40],
  popupAnchor: [-2, -35],
});
const iconFrei = L.icon({
  iconUrl: "/images/MapMarkerFrei.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [12.5, 32],
  popupAnchor: [-2, -35],
});
const iconNacht = L.icon({
  iconUrl: "/images/MapMarkerNacht.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [12.5, 32],
  popupAnchor: [-2, -35],
});
const iconStationär = L.icon({
  iconUrl: "/images/MapMarkerStationaer.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [12.5, 32],

  popupAnchor: [-2, -35],
});
const iconAmbulant = L.icon({
  iconUrl: "/images/MapMarkerAmbulant.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [12.5, 32],
  popupAnchor: [-2, -35],
});
const iconBeratung = L.icon({
  iconUrl: "/images/MapMarkerBeratung.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [12.5, 32],
  popupAnchor: [-2, -35],
});
const iconHospiz = L.icon({
  iconUrl: "/images/MapMarkerHospiz.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [12.5, 32],
  popupAnchor: [-2, -35],
});
const iconIntensiv = L.icon({
  iconUrl: "/images/MapMarkerIntensiv.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [12.5, 32],
  popupAnchor: [-2, -35],
});
const iconReha = L.icon({
  iconUrl: "/images/MapMarkerReha.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [12.5, 32],
  popupAnchor: [-2, -35],
});
const iconFull = L.icon({
  iconUrl: "/images/MapMarkerFull.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [12.5, 32],
  popupAnchor: [-2, -35],
});
const iconFullActive = L.icon({
  iconUrl: "/images/MapMarkerFullActive.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [20, 52],
  popupAnchor: [-2, -35],
});
const iconFreiActive = L.icon({
  iconUrl: "/images/MapMarkerFreiActive.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [20, 52],
  popupAnchor: [-2, -35],
});
const iconNachtActive = L.icon({
  iconUrl: "/images/MapMarkerNacht.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [20, 52],
  popupAnchor: [-2, -35],
});
const iconStationärActive = L.icon({
  iconUrl: "/images/MapMarkerStationaerActive.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [20, 52],

  popupAnchor: [-2, -35],
});
const iconAmbulantActive = L.icon({
  iconUrl: "/images/MapMarkerAmbulant.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [20, 52],
  popupAnchor: [-2, -35],
});
const iconBeratungActive = L.icon({
  iconUrl: "/images/MapMarkerBeratung.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [20, 52],
  popupAnchor: [-2, -35],
});
const iconHospizActive = L.icon({
  iconUrl: "/images/MapMarkerHospiz.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [20, 52],
  popupAnchor: [-2, -35],
});
const iconIntensivActive = L.icon({
  iconUrl: "/images/MapMarkerIntensiv.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [20, 52],
  popupAnchor: [-2, -35],
});
const iconRehaActive = L.icon({
  iconUrl: "/images/MapMarkerReha.png",
  // TODO: anchor auf Größe anpassen
  iconAnchor: [20, 52],
  popupAnchor: [-2, -35],
});
const CustomMarker = () => {
  const standort = usePos();
  const LeafIcon = L.Icon.extend({
    options: {},
  });
  const greenIcon = new LeafIcon({});
  const map = useMapEvents({
    click(e) {
      standort.setPosition([e.latlng.lat, e.latlng.lng]);
    },
  });
  const markerRef = useRef(null);
  const handleDrag = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          const pos = marker.getLatLng();
          standort.setPosition([pos.lat, pos.lng]);
        }
      },
    }),
    []
  );
  if (!standort || standort.position === null) return null;
  return (
    <Marker
      ref={markerRef}
      draggable
      eventHandlers={handleDrag}
      position={standort.position}
    />
  );
};
const Map = ({ ph, center, zoom, add, markerClick, active }) => {
  const router = useRouter();
  function getIcon(standort) {
    if (standort._id === active) {
      if (standort.request_stopp_from) return iconFullActive;
      if (standort.pflegeplätze?.length > 0) return iconFreiActive;
      if (standort.Kzp || standort.Lzp || standort.Tgp)
        return iconStationärActive;
      if (standort.Alp || standort.Support) return iconAmbulantActive;
      if (standort.Pflegestützpunkt) return iconBeratungActive;
      if (standort.Reha) return iconRehaActive;
      if (standort.Ivp) return iconIntensivActive;
      if (standort.Hospiz) return iconHospizActive;
      return iconFreiActive;
    }
    if (standort.request_stopp_from) return iconFull;
    if (standort.pflegeplätze?.length > 0) return iconFrei;
    if (standort.Kzp || standort.Lzp || standort.Tgp) return iconStationär;
    if (standort.Alp || standort.Support) return iconAmbulant;
    if (standort.Pflegestützpunkt) return iconBeratung;
    if (standort.Reha) return iconReha;
    if (standort.Ivp) return iconIntensiv;
    if (standort.Hospiz) return iconHospiz;
    return iconFrei;
  }

  return (
    <MapContainer
      center={center}
      scrollWheelZoom={false}
      zoom={
        !router.query.rng
          ? 18
          : router.query.rng * 1 <= 2
          ? 13
          : router.query.rng * 1 <= 5
          ? 12
          : router.query.rng * 1 <= 10
          ? 11
          : router.query.rng * 1 <= 20
          ? 10
          : router.query.rng * 1 <= 50
          ? 9
          : 18
      }
      style={{
        height: "100%",
      }}
    >
      <FullscreenControl forceSeparateButton={true} />

      <TileLayer
        attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
      />
      {/*       <MarkerClusterGroup> */}
      {ph.map((standort) => (
        <Marker
          icon={getIcon(standort)}
          key={standort._id}
          zIndexOffset={standort.pflegeplätze?.length > 0 ? 1000 : 0}
          index={standort._id}
          position={
            standort.Alp
              ? [standort.center.coordinates[1], standort.center.coordinates[0]]
              : [
                  standort.location.coordinates[1],
                  standort.location.coordinates[0],
                ]
          }
          eventHandlers={{
            click: () => markerClick(standort._id),
          }}
        >
          {/*             <Popup onClose={() => setActive(null)}>
              <ItemCarousel ph={standort} />
            </Popup> */}
        </Marker>
      ))}
      {/*       </MarkerClusterGroup> */}
      {add && <CustomMarker />}
    </MapContainer>
  );
};

export default Map;
